import React from 'react';
import PropTypes from 'prop-types';

import './TRLSection.css';

const TRLSection = ({ image }) => (
  <div id="ProjectTRL">
    <div className="blue" />
    <div className="black" />
    <div id="img">
      <img src={`https://voxarlabs.cin.ufpe.br/~voxarlabs/${image}`} alt="TRL scale" />
    </div>
  </div>
);


TRLSection.propTypes = {
  image: PropTypes.string.isRequired,
};

export default TRLSection;
